// extracted by mini-css-extract-plugin
export default {"modal":"Nzc1cjP2RMPPyaUvxTeg"};